import CanvasDrawing from './canvas-drawing';

export default CanvasDrawing;
